import { useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';

// utils
import { isPreviewSelector } from 'utils/selectors/environmentSelectors';
import { Log } from 'services/log';
import { useContent } from 'components/Page/page-hooks';
import { NavigationContext } from 'components/Navigation/NavigationContext';

const selectFn = process.env.JEST_WORKER_ID !== undefined ? () => {} : useSelector;
/**
 * Hook for accessing the GA datalayer
 * and logs for debugging purposes when on local or preview environment
 */
export function useTracking() {
  const isPreview = selectFn(isPreviewSelector);

  const content = useContent();
  const navigationContext = useContext(NavigationContext);
  // Gets the pageId from the context of the page and if this is empty, get it from the context of the navigation.
  const pageId = content?._id ?? navigationContext.content?._id;

  return useMemo(
    () => ({
      trackEvent: (data) => {
        const pushData = {
          'page-id': pageId,
          ...data,
        };
        if (
          (window && ['local.web.geberit.com', 'localhost'].includes(window.location.hostname)) ||
          isPreview
        ) {
          Log.info('TRACKING EVENT', pushData);
        }

        if (Array.isArray(window.dataLayer)) {
          window.dataLayer?.push(pushData);
        }
      },
    }),
    [isPreview],
  );
}
